import { CONFIG, type Entry, type Fixture } from '@h2h/shared';
import type { LadderRungGrade } from '../../../components/play/cycling-ui/ladderTypes';
import type { LadderRungData } from '../../../components/play/cycling-ui/StakeLadderRung';
import { buildDuelVMs } from '../../../lib/cyclingRound';

/** Build ranked ladder rungs + grade map for read-only StakeLadder on Stages / detail. */
export function buildStageLadder(entry: Entry, fixtures: Fixture[]) {
  const byId = new Map(fixtures.map((f) => [f.fixtureId, f]));
  const rungs: LadderRungData[] = [...entry.duelPicks!]
    .sort((a, b) => b.confidenceWeight - a.confidenceWeight)
    .map((p) => {
      const fixture = byId.get(p.duelId);
      if (!fixture) return null;
      return { duelId: p.duelId, pick: p.pick, fixture };
    })
    .filter(Boolean) as LadderRungData[];

  const weights = rungs.map((_, i) => CONFIG.CYCLING.CONFIDENCE_WEIGHTS[i] ?? 1);
  const grades = new Map<string, LadderRungGrade>();

  for (const vm of buildDuelVMs(entry, byId)) {
    grades.set(vm.duelId, {
      status: vm.status,
      correct: vm.correct,
      points: vm.points,
      pickedName: vm.pickedName,
      otherName: vm.otherName,
      confidence: vm.confidence
    });
  }

  return { rungs, weights, grades };
}
